import { useRef, useState } from 'react'
import { Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { AnimateBox } from '../../components/animate-box'
import { Pack } from '../../components/pack'
import { STATIC_OBS_URL } from '../../consts'

import type { Swiper as SwiperClass } from 'swiper/types'

import 'swiper/css'

const data = [
  {
    src: `${STATIC_OBS_URL}/website/original/d/file/p/2023/02-16/312c888dd8b66224fdc5a9c58d5094c3.mp4`,
    pic: `${STATIC_OBS_URL}/website/home/banner/1.png`,
    name: '世冠科技',
    descriptions: '系统仿真工业软件｜数字孪生解决方案提供商'
  },
  {
    src: `${STATIC_OBS_URL}/website/original/d/file/p/2023/02-02/545d81759101a08b5ac55132b3001134.mp4`,
    pic: `${STATIC_OBS_URL}/website/home/banner/2.png`,
    name: 'GCKontrol-GCAir一体工具链',
    descriptions: '取得ISO 26262认证｜覆盖系统开发的全生命周期，高效易用、软硬结合、仿真一体'
  },
  {
    src: `${STATIC_OBS_URL}/website/original/d/file/p/2023/02-16/284823fd167c6aeaeddbada0eb5d3fbe.mp4`,
    pic: `${STATIC_OBS_URL}/website/home/banner/3.png`,
    name: 'GCKontrol和GCAir的广泛应用',
    descriptions: '支撑大型复杂工业装备的设计和运维，实现装备数字孪生应用'
  },
  {
    src: `https://static-download.globalcrown.com.cn/website/pictures/mtr4q2g4-f6a4f28893a44250.mp4`,
    pic: `${STATIC_OBS_URL}/website/home/banner/4.png`,
    name: '头部客户100+｜工业企业用户1000',
    descriptions: '已服务于我国4大院士团队和7大行业头部用户 '
  }
]
export const BannerScroll = () => {
  const [progress, setProgress] = useState(0) // 进度条百分比
  const [activeIndex, setActiveIndex] = useState(0)
  const [isPlaying, setIsPlaying] = useState(true)
  const swiperRef = useRef<SwiperClass | null>(null)
  const isActiveRef = useRef(false)
  return (
    <AnimateBox animateFunction='fadeIn' className='scroll-banner'>
      <Swiper
        autoplay={{
          delay: 6000,
          disableOnInteraction: false
        }}
        className='container'
        loop={true} // 循环播放
        modules={[Autoplay]}
        slidesPerView={1}
        spaceBetween={30}
        onAutoplayTimeLeft={(_swiper, _time, progressValue) => {
          setProgress(1 - progressValue) // 进度条比例
        }}
        onSlideChange={swiper => {
          setActiveIndex(swiper.realIndex)
        }}
        onSwiper={swiper => {
          swiperRef.current = swiper // 保存 swiper 实例
        }}
      >
        {data.map(item => {
          const videoUrl = item.src
          const imgUrl = item.pic
          return (
            <SwiperSlide key={item.name}>
              <div className='slide'>
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className='video'
                  data-webkit-airplay='allow'
                  data-x5-video-orientation='portraint'
                  data-x5-video-player-fullscreen='true'
                >
                  <source src={videoUrl} type='video/mp4' />
                </video>
                <div className='img' style={{ backgroundImage: `url(${imgUrl})` }} />
                <div className='info'>
                  <div className='name'>{item.name}</div>
                  <div className='descriptions'>{item.descriptions}</div>
                  <a className='contact' href='/member/licenses'>
                    申请试用
                  </a>
                </div>
              </div>
            </SwiperSlide>
          )
        })}
      </Swiper>
      <div className='bar'>
        {data.map((item, index) => {
          const { name } = item
          const className = index === activeIndex ? 'active' : ''
          return (
            <button
              className={className}
              key={name}
              onClick={() => {
                swiperRef.current?.slideToLoop(index)
              }}
            >
              <div className='precent'>
                <Pack
                  className='inner'
                  if={index === activeIndex}
                  style={{ width: `${progress * 100}%` }}
                />
              </div>
              <span className='txt'>{name}</span>
            </button>
          )
        })}
      </div>
      <Pack
        className='stop-button'
        if={isPlaying}
        tagName='button'
        onClick={() => {
          setIsPlaying(false)
          swiperRef.current?.autoplay?.stop()
          isActiveRef.current = true
          document
            .querySelector('.scroll-banner')
            ?.querySelectorAll('video')
            .forEach(el => {
              el.pause()
            })
        }}
      />
      <Pack
        className='play-button'
        if={!isPlaying}
        tagName='button'
        onClick={() => {
          setIsPlaying(true)
          swiperRef.current?.autoplay?.start()
          isActiveRef.current = false
          document
            .querySelector('.scroll-banner')
            ?.querySelectorAll('video')
            .forEach(el => {
              void el.play()
            })
        }}
      />
      <div className='arrow-bottom' />
    </AnimateBox>
  )
}
